import { useEffect, useState } from "react";

const CONSENT_COOKIE = "essential_cookies_accepted";
const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

const hasConsentCookie = () =>
  document.cookie.split(";").some((cookie) => cookie.trim().startsWith(`${CONSENT_COOKIE}=`));

const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [cookieError, setCookieError] = useState(false);

  useEffect(() => {
    setIsVisible(!hasConsentCookie());
  }, []);

  const acceptEssentialCookies = () => {
    const secureAttribute = window.location.protocol === "https:" ? "; Secure" : "";

    document.cookie = `${CONSENT_COOKIE}=true; Path=/; Max-Age=${ONE_YEAR_IN_SECONDS}; SameSite=Lax${secureAttribute}`;

    if (hasConsentCookie()) {
      setCookieError(false);
      setIsVisible(false);
      return;
    }

    setCookieError(true);
  };

  if (!isVisible) return null;

  return (
    <section
      className="cookie-consent"
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
    >
      <div className="cookie-consent__content">
        <div className="cookie-consent__icon" aria-hidden="true">
          <i className="fa fa-lock" />
        </div>
        <div className="cookie-consent__copy">
          <h2 id="cookie-consent-title">Essential cookies required</h2>
          <p id="cookie-consent-description">
            We use essential cookies to keep your account secure and enable login. These cookies are
            required for the site to work and are not used for advertising.
          </p>
          {cookieError && (
            <p className="cookie-consent__error" role="alert">
              Cookies appear to be blocked. Please allow cookies for this site in your browser
              settings, then try again.
            </p>
          )}
        </div>
        <button className="cookie-consent__button" type="button" onClick={acceptEssentialCookies}>
          Accept essential cookies
        </button>
      </div>
    </section>
  );
};

export default CookieConsentBanner;
